import { FilterSchema } from '../../../../../core/base/interfaces/filter-schema.interface';
import { SupplierService } from '../../supplier/supplier.service';
import { GenericPrestationService } from '../../../settings/generic-prestation/generic-prestation.service';

export const PRESTATION_FILTER_SCHEMA: FilterSchema = {
  technicalIdentifier: { type: 'text' },
  reference: { type: 'text' },
  suppliers: { type: 'entity[]', resolve: { service: SupplierService, displayProperty: 'label' } },
  genericPrestations: {
    type: 'entity[]',
    resolve: { service: GenericPrestationService, displayProperty: 'label' },
  },
  // Valeurs distinctes projetées : la chip est la valeur elle-même, l'état autocomplete est fusionné sur ce champ
  labelList: { type: 'value[]', control: 'labels', valueField: 'label' },
  // Select simple émis en scalaire (`@SimpleFilter('purchaseUnit')` côté back)
  purchaseUnit: { type: 'option', options: 'purchaseUnitOptions' },
  // Booléen côté API (`@IsBoolean`), présenté par un select Oui/Non
  isSuspended: { type: 'boolean', options: 'suspensionOptions' },
};
